import React from 'react';
import styled from 'styled-components';
import LicenceSelectorQuestion from './licence_selector_question';
import I10n from '../features/i10n';
import { questionIsActive } from '../features/screens/licence_selector_screen/utils';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const QuestionGroupTitle = styled.span`
  color: #333333;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 10px;
`;

class LicenceSelectorQuestionGroup extends React.Component {

  getActiveQuestions = () => {
    const activeQuestions = [];

    for (const question of this.props.questionGroup.questions) {
      if (questionIsActive(question, this.props.userAnswers)) {
        activeQuestions.push(question);
      }
    }

    return activeQuestions;
  }

  render() {
    const { questionGroup, userAnswers, softwareLicencesMap } = this.props;

    const activeQuestions = this.getActiveQuestions();

    return (
      <>
        {activeQuestions.length > 0 && <Container key={questionGroup.key}>
          <QuestionGroupTitle>{I10n.getOrDefault(`screen.licence_selector.modal.question_group.name.${questionGroup.key}`, questionGroup.name)}</QuestionGroupTitle>
          {activeQuestions.filter(question => question.parentAnswer == null).map((question, idx) => (
            <LicenceSelectorQuestion
              key={idx}
              activeQuestions={activeQuestions}
              question={question}
              userAnswers={userAnswers}
              setAnswer={(key, value, answer) => { this.props.setAnswer(key, value, question, answer); }}
              clearAnswers={this.props.clearAnswers}
              softwareLicencesMap={softwareLicencesMap}
            />
          ))}
        </Container>}
      </>
    );
  }
}

export default LicenceSelectorQuestionGroup;
